<script setup>
import {onMounted, ref} from "vue";
import Button from "../../components/forms/Button.vue";
import {getLoggedUser} from '@/services/AuthService';
import ClientService from "@/services/ClientService";
import AccountManagersService from "@/services/AccountManagersService";
import {createConfirmDialog} from "vuejs-confirm-dialog";
import {showSuccessMessage} from "@/helper";
import router from "@/router";
import {useDataTable} from "@/utils/datatableHelper";
import IntermediaryService from "@/services/IntermediaryService";
import ModalDialog from "@/components/modals/ModalDialog.vue";
import CreateUpdateIntermediaryModal from "@/components/modals/CreateUpdateIntermediaryModal.vue";
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const datatableRef = ref(null);
const datatable = useDataTable(fetchIntermediaries, 'intermediary_name', 10, true, {}, 'INTERMEDIARIES-INDEX', datatableRef);
const intermediaries = ref(null);
const loggedUser = ref({});

const isEditable = ref(false);

const columns = ref([
  {
    label: t('intermediariesIndex.name'),
    field: 'intermediary_name',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: t('intermediariesIndex.email'),
    field: 'email',
    filterOptions: {
      enabled: true,
      skipDiacritics: true,
      placeholder: ' '
    }
  },
  {
    label: '',
    field: 'action',
    sortable: false,
    html: true
  },
]);

onMounted(() => {
  Promise.all([getLoggedUser()])
      .then(([userResponse]) => {
        loggedUser.value = userResponse;
        if (loggedUser.value.role === 'ADMIN' || loggedUser.value.role === 'SUPERADMIN' || loggedUser.value.role === 'BACK_OFFICE') {
          isEditable.value = true;
        }
      });
});

function fetchIntermediaries(body) {
  datatable.isLoading.value = true;
  IntermediaryService.fetchRecords(body).then(response => {
    datatable.totalRecords.value = response.meta.total;
    datatable.rows.value = response.data;
    datatable.isLoading.value = false;
  });
}

function createIntermediary() {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateUpdateIntermediaryModal, {});
  reveal();
  onConfirm((data) => {
    IntermediaryService.saveIntermediary(data).then(response => {
      showSuccessMessage(response.message);
      //router.push({name: 'ClientDetail', params: {id: response.client.id}});
      fetchIntermediaries(datatable.body);
    });
  });
  onCancel(() => {
  });
}
</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-3">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> {{t('intermediariesIndex.back')}}</a>
        </div>
        <div class="col-5 text-center">
          <div class="page-section__title">
           {{ t('intermediariesIndex.intermediaries_people')}}
          </div>
        </div>
        <div class="col-4 d-flex justify-content-end">
          <Button :label="t('intermediariesIndex.add_intermediaries')" icon="mdi-text-box-plus" @click="createIntermediary()"></Button>
        </div>
      </div>

    </div>
  </div>
  <div class="page-section__content">
    <div class="mt-3">
      <vue-good-table
          ref="datatableRef"
          :columns="columns"
          :rows="datatable.rows.value"
          mode="remote"
          @page-change="datatable.onPageChange"
          @sort-change="datatable.onSortChange"
          @column-filter="datatable.onColumnFilter"
          @per-page-change="datatable.onPerPageChange"
          :totalRows="datatable.totalRecords.value"
          :pagination-options="{
                  enabled: true,
                  rowsPerPageLabel: t('intermediariesIndex.add_record_page'),
                  nextLabel: t('intermediariesIndex.next'),
                  prevLabel: t('intermediariesIndex.previous'),
                  ofLabel: t('intermediariesIndex.z'),
                }">
        <template #table-row="props">
                            <span v-if="props.column.field == 'action'">
                                <span style="font-weight: bold; float: right">
                                    <router-link :to="{ name: 'IntermediaryDetail', params: { id: props.row.id} }"><button type="button" class="btn btn-link"><i class="mdi mdi-eye"/></button></router-link>
                                    </span>
                            </span>
        </template>
        <template v-slot:emptystate v-if="!datatable.isLoading.value">
          <div class="text-center">
            {{ t('intermediariesIndex.no_records_found')}}
          </div>
        </template>
        <template v-slot:emptystate v-if="datatable.isLoading.value">
          <div class="text-center">
            {{ t('intermediariesIndex.loading')}}
          </div>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<style scoped>

</style>
